export default {
	//贝码试用园所
	get IsFakeAccount() {
		return window.localStorage.IsFakeAccount;
	},
	set IsFakeAccount(IsFakeAccount) {
		window.localStorage.IsFakeAccount = IsFakeAccount;
	},
	get ServiceUnitId() {
		return window.localStorage.ServiceUnitId;
	},
	set ServiceUnitId(serviceUnitId) {
		window.localStorage.ServiceUnitId = serviceUnitId;
	},

	set ServiceUnitName(serviceUnitName) {
		window.localStorage.ServiceUnitName = serviceUnitName;
	},
	get ServiceUnitName() {
		return window.localStorage.ServiceUnitName;
    },
    get UnitType(){
        return window.localStorage.UnitType;
	},
	set UnitType(unitType){
		window.localStorage.UnitType = unitType;
	},
	get RoleType(){
        return window.localStorage.RoleType;
	},
	set RoleType(roleType){
		window.localStorage.RoleType = roleType;
	},
	get KindergartenName(){
		return window.localStorage.KindergartenName;
	},
	set KindergartenName(kindergartenName){
		window.localStorage.KindergartenName = kindergartenName;
	},
	get KindergartenId(){
		return window.localStorage.KindergartenId;
	},
	set KindergartenId(kindergartenId){
		window.localStorage.KindergartenId = kindergartenId;
	},
	get AgencyId(){
		return window.localStorage.AgencyId;
	},
	set AgencyId(agencyId){
		window.localStorage.AgencyId = agencyId;
	},
	get AllianceId(){
		return window.localStorage.AllianceId;
	},
	set AllianceId(allianceId){
		window.localStorage.AllianceId = allianceId;
	},
	get ProxyId(){
		return window.localStorage.ProxyId;
	},
	set ProxyId(proxyId){
		window.localStorage.ProxyId = proxyId;
	},

	get ProjectName(){
		return window.localStorage.ProjectName;
	},
	set ProjectName(projectName){
		window.localStorage.ProjectName = projectName;
	},
	get ProjectCreatTime(){
		return window.localStorage.ProjectCreatTime;
	},
	set ProjectCreatTime(projectCreatTime){
		window.localStorage.ProjectCreatTime = projectCreatTime;
	},
	get ProjectDescription(){
		return window.localStorage.ProjectDescription;
	},
	set ProjectDescription(projectDescription){
		window.localStorage.ProjectDescription = projectDescription;
	},
	get UserId(){
		return window.localStorage.UserId;
	},
	set UserId(userId){
		window.localStorage.UserId = userId;
	},
	get ProjectStatus(){
		return window.localStorage.ProjectStatus;
	},
	set ProjectStatus(projectStatus){
		window.localStorage.ProjectStatus = projectStatus;
	},

	get ProjectId(){
		return window.localStorage.ProjectId;
	},
	set ProjectId(projectId){
		window.localStorage.ProjectId = projectId;
	},

	get ServiceUnitGrade(){
		return window.localStorage.ServiceUnitGrade;
	},
	set ServiceUnitGrade(serviceUnitGrade){
		window.localStorage.ServiceUnitGrade = serviceUnitGrade;
	},
	get GartenId(){
		return window.localStorage.GartenId;
	},
	set GartenId(gartenId){
		window.localStorage.GartenId = gartenId;
	},

	get ChildId(){
		return window.localStorage.ChildId;
	},
	set ChildId(childId){
		window.localStorage.ChildId = childId;
	},
	get TargetMonth(){
		return window.localStorage.TargetMonth;
	},
	set TargetMonth(targetMonth){
		window.localStorage.TargetMonth = targetMonth;
	},
	get TargetYear(){
		return window.localStorage.TargetYear;
	},
	set TargetYear(targetYear){
		window.localStorage.TargetYear = targetYear;
	},

	get Grade(){
		return window.localStorage.Grade;
	},
	set Grade(grade){
		window.localStorage.Grade = grade;
    },
    //报告模板判断
	set RequestUnit(requestUnit){
		window.localStorage.RequestUnit = requestUnit
	},
	get RequestUnit(){
		return window.localStorage.RequestUnit;
    },
     //主题色
	set ThemeColor(themeColor){
		window.localStorage.ThemeColor = themeColor
	},
	get ThemeColor(){
		return window.localStorage.ThemeColor;
    },
     //试用园
    set IsProbation(isProbation){
		window.localStorage.IsProbation = isProbation
	},
	get IsProbation(){
		return window.localStorage.IsProbation;
    },
     //试用园
    //  set IsProbation(allianceName){
	// 	window.localStorage.AllianceName = allianceName
	// },
	// get IsProbation(){
	// 	return window.localStorage.AllianceName;
	// },
	Clear: function() {
		window.localStorage.clear();
    }


}



// WEBPACK FOOTER //
// ./src/utils/context.js